import axios from "axios";
import { UserSession } from "../user_session";
import * as Vars from "./Vars";

export class AuthSettings {

    /**
     * Retrieves the authentication settings/configurations from the given project.
     * @param {number} project_id The project ID, from where the configurations should be loaded.
     */
    static async load(project_id){
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/auth_settings/",
                method: "GET",
                params: {
                    _console_token: UserSession.token,
                    project: project_id
                }
            }).then(function(data){
                resolve(data.data);
            });
        });
    }

    /**
     * Updates the authentication settings according to the given parameters.
     * @param {number} project_id The project, where it should be created/updated.
     * @param {string} name The name of the sender.
     * @param {string} sender The email address of the sender.
     * @param {string} host The hostname of the mailserver.
     * @param {string} username The username of the mail account.
     * @param {string} password The password of the mail account.
     * @param {number} port The port to connect to the mail server.
     */
    static async update(project_id, name, sender, host, username, password, port){
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/auth_settings/",
                method: "PUT",
                data: {
                    _console_token: UserSession.token,
                    project: project_id,
                    name: name,
                    sender: sender,
                    host: host,
                    username: username,
                    password: password,
                    port: port
                }
            }).then(function(data){
                resolve(data.data);
            });
        });
    }

    static async getMailTemplate(project_id, key, lang){
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/auth_settings/templates.php",
                method: "GET",
                params: {
                    _console_token: UserSession.token,
                    project: project_id,
                    key: key,
                    lang: lang
                }
            }).then(function(data){
                resolve(data.data);
            });
        });
    }

    static async saveMailTemplate(project_id, key, lang, subject, content){
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/auth_settings/templates.php",
                method: "PUT",
                data: {
                    _console_token: UserSession.token,
                    project: project_id,
                    key: key,
                    lang: lang,
                    subject: subject,
                    content: content
                }
            }).then(function(data){
                resolve(data.data);
            });
        });
    }

    static async getMailLinks(project_id) {
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/auth_settings/links.php",
                method: "GET",
                params: {
                    _console_token: UserSession.token,
                    project: project_id
                }
            }).then(function(data){
                resolve(data.data);
            });
        });
    }

    static async saveMailLinks(project_id, link_reset, link_activate) {
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/auth_settings/links.php",
                method: "PUT",
                data: {
                    _console_token: UserSession.token,
                    project: project_id,
                    link_reset: link_reset,
                    link_activate: link_activate
                }
            }).then(function(data){
                resolve(data.data);
            });
        });
    }

    static async getAllUsers(project_id) {
        return new Promise((resolve) => {
            axios({
                 url: Vars.API_ENDPOINT + "/console_api/v1/auth_settings/users.php",
                 method: "GET",
                 params: {
                    _console_token: UserSession.token,
                    project: project_id
                 }
            }).then(function(data) {
                resolve(data.data)
            });
        });
    }

    static async createUser(project_id, email, password, language) {
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/auth_settings/users.php",
                method: "POST",
                data: {
                    _console_token: UserSession.token,
                    project: project_id,
                    email: email,
                    password: password,
                    lang: language
                }
            }).then(function(response) {
                resolve(response.data);
            });
        });
    }

    static deactivateOTP(project_id, user_id) {
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/auth_settings/users.php",
                method: "DELETE",
                data: {
                    _console_token: UserSession.token,
                    function: "disable_otp",
                    project: project_id,
                    user_id: user_id
                }
            }).then(function(response) {
                resolve(response.data);
            });
        });
    }

    static async setActiveStatus(project_id, user_id, status) {
        var function_text;
        if (status) {
            function_text = "ACTIVATE";
        } else {
            function_text = "DEACTIVATE";
        }

        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/auth_settings/users.php",
                method: "PUT",
                data: {
                    _console_token: UserSession.token,
                    function: function_text,
                    project: project_id,
                    user_id: user_id
                }
            }).then(function(response) {
                resolve(response.data);
            });
        });
    }

    static async deleteUser(project_id, user_id) {
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/auth_settings/users.php",
                method: "DELETE",
                data: {
                    _console_token: UserSession.token,
                    project: project_id,
                    user_id: user_id
                }
            }).then(function(response) {
                resolve(response.data);
            });
        });
    }

    static async updatePassword(project_id, user_id, password) {
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/auth_settings/users.php",
                method: "PUT",
                data: {
                    _console_token: UserSession.token,
                    function: "UPDATE_PASSWORD",
                    project: project_id,
                    user_id: user_id,
                    password: password
                }
            }).then(function(response) {
                resolve(response.data);
            });
        });
    }

    static getDisabledNewRegistrations(project_id) {
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/auth_settings/",
                method: "GET",
                params: {
                    _console_token: UserSession.token,
                    project: project_id,
                    function: "allow_registrations"
                }
            }).then(function(response) {
                resolve(response.data);
            });
        });
    }

    static toggleDisableRegistration(project_id) {
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/auth_settings/",
                method: "PUT",
                data: {
                    _console_token: UserSession.token,
                    project: project_id,
                    function: "toggle_allow_registration"
                }
            }).then(function(data){
                resolve(data.data);
            });
        });
    }

    static getAdditionalLoginInfo(project_id) {
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/auth_settings/",
                method: "GET",
                params: {
                    _console_token: UserSession.token,
                    project: project_id,
                    function: "additional_login_info"
                }
            }).then(function(data){
                resolve(data.data);
            });
        });
    }
    static saveAdditionalLoginInfo(project_id, value) {
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/auth_settings/",
                method: "PUT",
                data: {
                    _console_token: UserSession.token,
                    project: project_id,
                    function: "additional_login_info",
                    value: value
                }
            }).then(function(data){
                resolve(data.data);
            });
        });
    }

    /**
     * Enables the OTP option to setup the 2FA.
     * @param {Number} project_id The id of the project
     */
    static enableOTPSetup(project_id) {
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/auth_settings/",
                method: "PUT",
                data: {
                    _console_token: UserSession.token,
                    project: project_id,
                    function: "enable_otp_setup"
                }
            }).then(function(data){
                resolve(data.data);
            });
        });
    }

    /**
     * Disables the OTP option to setup the 2FA.
     * @param {Number} project_id The id of the project
     */
    static disableOTPSetup(project_id) {
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/auth_settings/",
                method: "PUT",
                data: {
                    _console_token: UserSession.token,
                    project: project_id,
                    function: "disable_otp_setup"
                }
            }).then(function(data){
                resolve(data.data);
            });
        });
    }

    /**
     * Fetches the state, if the OTP setup is allowed.
     * @param {Number} project_id The project id
     */
    static getOTPSetupAllowed(project_id) {
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/auth_settings/",
                method: "GET",
                params: {
                    _console_token: UserSession.token,
                    project: project_id,
                    function: "otp_allowed"
                }
            }).then(function(data){
                resolve(data.data);
            });
        });
    }
}